<template>
<div class="top-head">
    <div class="warrp">
        <a target="_blank" href="//yorkbbs.ca" class="logo">YorkBBS.CA</a>
        <div class="flex-cont"></div>
        <div class="nav">
            <a target="_blank" href="//yorkbbs.ca">网站首页</a>
            <a target="_blank" href="//news.yorkbbs.ca">新闻</a>
            <a target="_blank" href="//forum.yorkbbs.ca">论坛</a>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name:'SimpleHead',
    
}
</script>
<style lang="less" scoped>
.top-head{
    position: absolute; z-index: 5; left: 0; top: 0; right: 0; background: rgba(0,0,0,0.10);
    .warrp{
        display: flex; align-items: center; padding: 0 15px; height: 40px;
        .logo{font-size: 16px; line-height: 40px; color: #fff; font-weight: bold;}
        .flex-cont{flex:1;}
        .nav{
            display: flex; align-items: center;
            a{
                font-size: 14px; line-height: 20px; color: #fff; text-decoration: none;margin-left:20px;
                &:hover{text-decoration: underline;}
            }
        }
    }
}
@media screen and (min-width:768px){
    .top-head{
        .warrp{max-width: 1170px; margin:0 auto;}
    } 
   
}
</style>